import React from 'react';
import AuFormItemWrapper from '../AuFormItemWrapper/AuFormItemWrapper';

import './AuFormGroup.scss';

interface IAuFormGroup {
  className?: string;
  status?: 'invalid' | 'valid';
  style?: React.CSSProperties;
};

/**
 * The form group component
 */
const AuFormGroup: React.FC<IAuFormGroup> = ({ children, status = '', className = '', ...attributeOptions }) => (
  <AuFormItemWrapper className={
    `au-form-group ${className}` +
    `${status === 'invalid' ? ' au-form-group--invalid ' : ''}`
  }
  {...attributeOptions}
  >
    {children}
  </AuFormItemWrapper>
);

export default AuFormGroup;
